const REGISTER_OF_MEMBERS_DOCUMENT_TYPES = {
  SHAREHOLDER_REGISTRY: {
    value: "shareholder_registry",
    readableName: "Shareholder Registry",
  },
  CAP_TABLE: {
    value: "cap_table",
    readableName: "Cap Table",
  },
  OTHER: {
    value: "other",
    readableName: "Other",
  },
};

export const registerOfMembersDocumentTypesArray = Object.values(
  REGISTER_OF_MEMBERS_DOCUMENT_TYPES,
);
